import { isObjectEmpty } from 'src/utils/aem-utils/utils';
import { ValidationOutcomes, ValidationResult } from '.';

const ValidateTextLockupComponentProps = (props: any): ValidationResult => {
  let vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
  };

  if (!props || isObjectEmpty(props)) {
    vr.result = ValidationOutcomes.FAILURE;
    vr.messages.push('TextLockup - No props provided. {}');
    return vr;
  }

  if (!props.children && !props.heading && !props.subheading) {
    vr.result = ValidationOutcomes.FAILURE;
    vr.messages.push(
      'TextLockup - No valid content. Please provide children, heading or subheading.',
    );
    return vr;
  }

  vr.componentProps = props;
  vr.result = ValidationOutcomes.SUCCESS;
  return vr;
};

export default ValidateTextLockupComponentProps;
